// @flow

import type { Action } from './store.type';

export const UPDATE_SCOPES_REQUEST = 'UPDATE_SCOPES_REQUEST';
type UPDATE_SCOPES_REQUEST_TYPE = 'UPDATE_SCOPES_REQUEST';

export const UPDATE_SCOPES_SUCCESS = 'UPDATE_SCOPES_SUCCESS';
type UPDATE_SCOPES_SUCCESS_TYPE = 'UPDATE_SCOPES_SUCCESS';

export const UPDATE_SCOPES_FAILURE = 'UPDATE_SCOPES_FAILURE';
type UPDATE_SCOPES_FAILURE_TYPE = 'UPDATE_SCOPES_FAILURE';

type AppPermissionSuccess = {
  accessScopes: {}
};

type AppPermissionFailure = {
  error: any
};

type UpdateScopesRequestAction = Action<UPDATE_SCOPES_REQUEST_TYPE, null>;

type UpdateScopesSuccessAction = Action<UPDATE_SCOPES_SUCCESS_TYPE, AppPermissionSuccess>;

type UpdateScopesFailureAction = Action<UPDATE_SCOPES_FAILURE_TYPE, AppPermissionFailure>;

export const GET_PERMISSION_LINK_REQUEST = 'GET_PERMISSION_LINK_REQUEST';
export const GET_PERMISSION_LINK_SUCCESS = 'GET_PERMISSION_LINK_SUCCESS';
export const GET_PERMISSION_LINK_FAILURE = 'GET_PERMISSION_LINK_FAILURE';

export type AppPermissionAction =
  | UpdateScopesRequestAction
  | UpdateScopesSuccessAction
  | UpdateScopesFailureAction;

export type AppPermissionState = {
  loading: boolean,
  success: boolean,
  error: any,
  accessScopes: Object,
  permissionLinkGetting: boolean,
  permissionLink: string | null
};
